@if (activity?.associations?.length > 0) {
  @if (!hideDivider) {
    <hr class="association-divider" />
  }
  <div class="row">
    @if (numberOfAssociations()) {
      <a [glxyPopover]="associations" (click)="openPopover(activity)" class="associations-popup-link">
        <mat-icon class="associations-icon">link</mat-icon>
        <span class="association-count">
          {{ numberOfAssociations() }}
        </span>
      </a>
    }
    @if (teamMembersAvatars()?.length > 0) {
      <glxy-avatar-group class="association-team-members" [avatarWidth]="27" [avatarList]="this.teamMembersAvatars()" />
    }
  </div>
}
<glxy-popover
  #associations
  [(isOpen)]="popupOpen[activity.crmObjectId]"
  [closeOnBackdropClick]="true"
  [closeOnEscapeKey]="true"
  [positions]="[PopoverPositions.Bottom, PopoverPositions.Top]"
  [maxHeight]="400"
>
  @if (contacts()?.length > 0) {
    <div class="association">
      <div class="subtitle">{{ 'ACTIVITY.POPOVER.CONTACTS' | translate }}</div>
      @for (contact of contacts(); track $index) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: contact }"
        ></ng-container>
      }
    </div>
  }
  @if (companies()?.length > 0) {
    <div class="association">
      <div class="subtitle">{{ 'ACTIVITY.POPOVER.COMPANIES' | translate }}</div>
      @for (company of companies(); track $index) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: company }"
        ></ng-container>
      }
    </div>
  }
  @if (customObjectGroups()?.length > 0) {
    @for (customObjectGroup of customObjectGroups(); track $index) {
      <div class="association">
        <div class="subtitle">
          {{ 'OBJECT.TITLE' | translate: { pluralObjectName: customObjectGroup.objectGroupName } }}
        </div>
        @for (customObject of customObjectGroup.activityAssociationDisplayInfo; track customObject) {
          <ng-container
            [ngTemplateOutlet]="itemTemplate"
            [ngTemplateOutletContext]="{ $implicit: customObject }"
          ></ng-container>
        }
      </div>
    }
  }
  @if (opportunities()?.length > 0) {
    <div class="association">
      <div class="subtitle">{{ 'ACTIVITY.POPOVER.OPPORTUNITIES' | translate }}</div>
      @for (opportunity of opportunities(); track $index) {
        <ng-container
          [ngTemplateOutlet]="itemTemplate"
          [ngTemplateOutletContext]="{ $implicit: opportunity }"
        ></ng-container>
      }
    </div>
  }
</glxy-popover>

<ng-template #itemTemplate let-item>
  @if (item.linkUrl && !isMultiLocation()) {
    <div>
      <a [routerLink]="routePrefix() + '/' + item.linkUrl">
        {{ item.name }}
      </a>
    </div>
  } @else {
    <div>{{ item.name }}</div>
  }
</ng-template>
